import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { UserGroupEffects } from './user-group.effects';
import { userGroupReducer } from './user-group.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('userGroups', userGroupReducer),
    EffectsModule.forFeature([UserGroupEffects]),
  ],
  providers: [],
})
export class UserGroupStoreModule {}
